module.exports = __webpack_public_path__ + "static/media/report-damage.395425fd.svg";